/* Munier | wd-testimonials carousel | 2026-10-30
   התוכן מרונדר ב-HTML והקרוסלה היא scroll-snap. הקובץ מוסיף רק חיצים ו-autorotate. נטען רק ב-layout=carousel, defer. */
(function () {
  if (customElements.get('wd-testimonials')) return;
  customElements.define('wd-testimonials', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.wd-tm__track');
      this.nav = this.querySelector('.wd-tm__nav');
      if (!this.track) return;
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      if (this.track.scrollWidth > this.track.clientWidth + 4 && this.nav) {
        this.nav.hidden = false;
        this.nav.addEventListener('click', (e) => {
          const b = e.target.closest('[data-dir]');
          if (!b) return;
          this.stop();
          this.go(b.dataset.dir === 'next' ? 1 : -1);
        });
      }
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autorotate === 'true' && !reduce) {
        this.speed = parseInt(this.dataset.speed, 10) || 5000;
        ['pointerenter', 'focusin', 'touchstart'].forEach((ev) => this.addEventListener(ev, () => this.stop(), { passive: true }));
        this.addEventListener('pointerleave', () => this.start());
        this.start();
      }
    }
    disconnectedCallback() { this.stop(); }
    step() {
      const item = this.track.querySelector('.wd-tm__item');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
    }
    atEnd() { return Math.abs(this.track.scrollLeft) + this.track.clientWidth >= this.track.scrollWidth - 4; }
    go(dir) {
      if (dir > 0 && this.atEnd()) { this.track.scrollTo({ left: 0 }); return; }
      const dx = this.step() * dir * (this.rtl ? -1 : 1);
      this.track.scrollBy({ left: dx });
    }
    start() {
      if (!this.speed || this.timer) return;
      this.timer = setInterval(() => { if (!document.hidden) this.go(1); }, this.speed);
    }
    stop() { clearInterval(this.timer); this.timer = null; }
  });
})();
